import Seo from '@/components/Seo';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import HeroSection from '@/components/sections/HeroSection';
import ProblemSolutionSection from '@/components/sections/ProblemSolutionSection';
import ServiceModelsSection from '@/components/sections/ServiceModelsSection';
import CapabilitiesSection from '@/components/sections/CapabilitiesSection';
import WhyUsSection from '@/components/sections/WhyUsSection';
import LocationSection from '@/components/sections/LocationSection';
import RegionSection from '@/components/sections/RegionSection';
import ProcessSection from '@/components/sections/ProcessSection';
import GallerySection from '@/components/sections/GallerySection';
import FactsSection from '@/components/sections/FactsSection';
import DualCTASection from '@/components/sections/DualCTASection';

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="CNC-Fertigung Stamsried | Express & kostenoptimiert – SR-Zerspanung"
        description="CNC-Fräsen 3- und 5-Achs für Automatisierungstechnik und Sondermaschinenbau aus Stamsried in der Oberpfalz. Express-Fertigung oft am selben Tag, bis zu 40% Kostenersparnis."
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'SR-Zerspanung',
          url: 'https://www.sr-zerspanung.de',
          inLanguage: 'de-DE',
        }}
      />
      <Header />
      <main>
        <HeroSection />
        <ProblemSolutionSection />
        <ServiceModelsSection />
        <CapabilitiesSection />
        <FactsSection />
        <WhyUsSection />
        <ProcessSection />
        <GallerySection />
        <LocationSection />
        <RegionSection />
        <DualCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
